var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Angle-Left_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 8,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.592 3 4.57 7.623a.517.517 0 0 0 0 .754L9.592 13",
    stroke: "#14161A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Angle-Left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14161A",
    d: "M0 0h16v16H0z"
  }))));
};
export { SvgAngleLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzIxODdfMjcxMyIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMyIgeT0iMiIgd2lkdGg9IjgiIGhlaWdodD0iMTIiPgo8cGF0aCBkPSJNOS41OTE1NSAzTDQuNTcwMDQgNy42MjMwOEM0LjUxODUzIDcuNjcxNDIgNC40Nzc0NyA3LjcyOTgxIDQuNDQ5NDEgNy43OTQ2NEM0LjQyMTM0IDcuODU5NDcgNC40MDY4NiA3LjkyOTM2IDQuNDA2ODYgOEM0LjQwNjg2IDguMDcwNjQgNC40MjEzNCA4LjE0MDU0IDQuNDQ5NDEgOC4yMDUzNkM0LjQ3NzQ3IDguMjcwMTkgNC41MTg1MyA4LjMyODU4IDQuNTcwMDQgOC4zNzY5Mkw5LjU5MTU1IDEzIiBzdHJva2U9IiMxNDE2MUEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzIxODdfMjcxMykiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMxNDE2MUEiLz4KPC9nPgo8L3N2Zz4K";